"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = require("react");

var _material = require("@mui/material");

var _TextField = require("../TextField");

var _IconButton = require("../IconButton");

var _MenuItem = require("../MenuItem");

var _MenuButton = require("../MenuButton");

var _DataTableHead = _interopRequireDefault(require("./DataTableHead"));

var _DataTableBody = _interopRequireDefault(require("./DataTableBody"));

var _utils = require("./utils");

var _utilities = require("../../utilities");

var _jsxRuntime = require("react/jsx-runtime");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var StyledTextField = (0, _material.styled)(_TextField.TextField)(function (_ref) {
  var theme = _ref.theme,
      disabled = _ref.disabled;
  return (0, _defineProperty2.default)({}, "&.".concat(_utilities.classes.components.MuiTextField.root), (0, _defineProperty2.default)({}, "& .".concat(_utilities.classes.components.MuiInputBase.root, ":hover"), {
    borderColor: disabled ? theme.palette.brand.grey.stone : undefined
  }));
});
var StyledTableContainer = (0, _material.styled)(_material.TableContainer, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== "disabled";
  }
})(function (_ref3) {
  var _ref3$disabled = _ref3.disabled,
      disabled = _ref3$disabled === void 0 ? false : _ref3$disabled;
  return {
    opacity: disabled ? "0.5" : undefined
  };
});

var DataTable = function DataTable(_ref4) {
  var ariaLabels = _ref4.ariaLabels,
      columns = _ref4.columns,
      rowGetter = _ref4.rowGetter,
      staticRows = _ref4.staticRows,
      fileGetter = _ref4.fileGetter,
      emptyText = _ref4.emptyText,
      radio = _ref4.radio,
      checkbox = _ref4.checkbox,
      searchPlaceholder = _ref4.searchPlaceholder,
      providedOptions = _ref4.options,
      onUpdateSearchSort = _ref4.onUpdateSearchSort,
      linkRenderer = _ref4.linkRenderer,
      _ref4$hideSearch = _ref4.hideSearch,
      hideSearch = _ref4$hideSearch === void 0 ? false : _ref4$hideSearch,
      _ref4$disabled = _ref4.disabled,
      disabled = _ref4$disabled === void 0 ? false : _ref4$disabled,
      actionsDropdown = _ref4.actionsDropdown,
      onDataTableInit = _ref4.onDataTableInit,
      caption = _ref4.caption,
      tableText = _ref4.tableText,
      _ref4$SearchFieldProp = _ref4.SearchFieldProps,
      SearchFieldProps = _ref4$SearchFieldProp === void 0 ? {} : _ref4$SearchFieldProp,
      _ref4$DownloadButtonP = _ref4.DownloadButtonProps,
      DownloadButtonProps = _ref4$DownloadButtonP === void 0 ? {} : _ref4$DownloadButtonP;
  var dataTableBodyRef = (0, _react.useRef)();

  var _useState = (0, _react.useState)(""),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      search = _useState2[0],
      setSearch = _useState2[1];

  var _useState3 = (0, _react.useState)([]),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      sortBy = _useState4[0],
      setSortBy = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      isDownloading = _useState6[0],
      setIsDownloading = _useState6[1];

  var _useState7 = (0, _react.useState)("unchecked"),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      parentCheckboxState = _useState8[0],
      setParentCheckboxState = _useState8[1];

  var options = _objectSpread(_objectSpread({}, _utils.defaultOptions), providedOptions);

  if (staticRows && rowGetter) {
    throw new Error("`staticRows` and `rowGetter` cannot both be used simultaneously - use one or the other.");
  }

  if (radio && checkbox) {
    throw new Error("`radio` and `checkbox` cannot both be used simultaneously - use one or the other.");
  }

  (0, _react.useEffect)(function () {
    if (onDataTableInit) {
      onDataTableInit({
        refreshTableContents: function refreshTableContents() {
          var _dataTableBodyRef$cur;

          (_dataTableBodyRef$cur = dataTableBodyRef.current) === null || _dataTableBodyRef$cur === void 0 ? void 0 : _dataTableBodyRef$cur.getRows();
        }
      });
    }
  }, [onDataTableInit]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [(fileGetter || !hideSearch) && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Box, {
      mb: 3,
      children: [!hideSearch && /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledTextField, _objectSpread({
        "aria-label": ariaLabels.search,
        disabled: !columns || disabled,
        onChange: function onChange(e) {
          return setSearch(e.target.value);
        },
        placeholder: searchPlaceholder,
        type: "search",
        value: search
      }, SearchFieldProps)), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Box, {
        component: "span",
        mr: 2
      }), fileGetter && !disabled && /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton.IconButton, _objectSpread({
        "aria-label": ariaLabels.download,
        disabled: !columns,
        iconName: "download",
        isBusy: isDownloading,
        onClick: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
          return _regenerator.default.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  setIsDownloading(true);
                  _context.next = 3;
                  return fileGetter({
                    search: search,
                    sort: sortBy
                  });

                case 3:
                  setIsDownloading(false);

                case 4:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        })),
        size: "medium"
      }, DownloadButtonProps)), actionsDropdown && /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Box, {
        sx: {
          float: "right"
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuButton.MenuButton, _objectSpread(_objectSpread({}, actionsDropdown), {}, {
          children: actionsDropdown.menuItems.map(function (menuItem) {
            return /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem.MenuItem, {
              label: menuItem.label,
              onClick: menuItem.onClick
            }, menuItem.label);
          })
        }))
      })]
    }), tableText && /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Typography, {
      pt: 2,
      pb: 1,
      children: tableText
    }), columns ? /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledTableContainer, _objectSpread(_objectSpread({}, options.tableContainerProps), {}, {
      disabled: disabled,
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Table, {
        stickyHeader: options.hasStickyHeader,
        children: [caption && /*#__PURE__*/(0, _jsxRuntime.jsx)("caption", {
          children: caption
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_DataTableHead.default, {
          checkbox: checkbox === null || checkbox === void 0 ? void 0 : checkbox.enabled,
          checkboxAriaLabel: checkbox === null || checkbox === void 0 ? void 0 : checkbox.parentAriaLabel,
          checkboxState: parentCheckboxState,
          columns: columns,
          disabled: disabled,
          linkRenderer: linkRenderer,
          radio: radio === null || radio === void 0 ? void 0 : radio.enabled,
          setCheckboxState: setParentCheckboxState,
          setSortBy: setSortBy,
          sortBy: sortBy
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_DataTableBody.default, {
          checkbox: checkbox,
          columns: columns,
          disabled: disabled,
          emptyText: emptyText,
          linkRenderer: linkRenderer,
          onUpdateSearchSort: onUpdateSearchSort,
          options: options,
          parentCheckboxState: parentCheckboxState,
          radio: radio,
          rowGetter: rowGetter,
          search: search,
          setParentCheckboxState: setParentCheckboxState,
          sortBy: sortBy,
          staticRows: staticRows,
          ref: dataTableBodyRef
        })]
      })
    })) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.CircularProgress, {})]
  });
};

DataTable.CellRenders = _utils.CellRenders;
var _default = DataTable;
exports.default = _default;